
const ReserveResponse = {
	"tktTimeLimit": "2018-05-06T13:30:00",
	"priceChange": true,
	"gdsRefrenceID": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
	"reserveCode": "PO0000001",
	"adultCount": 1,
	"childCount": 0,
	"infantCount": 0	
  };
   
  
    export default ReserveResponse;
    